import React, { ReactElement } from 'react';
import CreateJobHeader, { CreateJobHeaderProps } from './CreateJobHeader';
import './JobPageContainer.scss';

export default function JobPageContainer(props: Props) {
	return (
		<React.Fragment>
			<CreateJobHeader engagementId={props.engagementId} jobName={props.jobName} progressStatus={props.progressStatus} />
			<div className="job-page-container__container">
				{props.children}
			</div>
		</React.Fragment>
	);
}

interface Props extends CreateJobHeaderProps {
	children: ReactElement;
}
